import React from "react"
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import MenuBookIcon from '@mui/icons-material/MenuBook';
import { useNavigate } from 'react-router';
import { Button, Box, Grid, Typography, Paper } from '@mui/material'
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import AssessmentCardInProgress from "../home/AssessmentCardInProgress";
import AssessmentCardComplete from "../home/AssessmentCardComplete";
import AssessmentCardStart from "../home/AssessmentCardStart";
import AssessmentCardCampaign from "../home/AssessmentCardCampaign";

const motionVariants = {
    hidden: { opacity: 0, x: 0, y: 0 },
    show: {
        opacity: 1, x: 0, y: 0,
        transition: {
            delay: 0.1,
            duration: 0.5,
        }
    }
}

const HomeAssessmentLibrary = (props) => {
    // const AssessmentList = props.AssessmentLibrary.Assessments
    const {component}=props
    const AssessmentList = component.Data
    //console.log('lib props', props)

    const navigate = useNavigate();


    const AssessmentCard = ({ AssessmentObject, LargeCard, settings }) => {
        const { InProgressFlag, CompletedFlag, DisplayMode } = AssessmentObject

        if (DisplayMode=='1') {
            return (
                <Grid item xs={12} md={LargeCard ? 8 : 4}>
                    
                    <AssessmentCardCampaign AssessmentObject={AssessmentObject} LargeCard={LargeCard} settings={settings} />
                </Grid>
            )
        } else if (DisplayMode=='2') {
            return (
                <Grid item xs={12} md={LargeCard ? 8 : 4}>

                    <AssessmentCardComplete AssessmentObject={AssessmentObject} LargeCard={LargeCard} settings={settings} />
                </Grid>
            )
        } else if (DisplayMode=='3')  {
            return (
                <Grid item xs={12} md={LargeCard ? 8 : 4}>
                    <AssessmentCardStart AssessmentObject={AssessmentObject} LargeCard={LargeCard} settings={settings} />
                </Grid>
            )
            
        }else if (DisplayMode=='4')  {
            return (
                <Grid item xs={12} md={LargeCard ? 8 : 4}>
            <AssessmentCardInProgress AssessmentObject={AssessmentObject} LargeCard={LargeCard} settings={settings} />
                </Grid>
            )
            
        }else   {
            return (
                <Grid item xs={12} md={LargeCard ? 8 : 4}>
                    <Typography variant="h6">Invalid DisplayMode</Typography>
                </Grid>
            )
            
        }
    }


    return (
        <Box px={2}>
            <Grid container direction="row" alignItems="top" justifyContent="center" spacing={3}>
                {

                    AssessmentList.map((x, i) => {

                        return (


                            <AssessmentCard AssessmentObject={x} LargeCard={false} settings={props.otherprops.settings} />
                        )

                    }

                    )
                }


            </Grid>
        </Box>
    )

}

export default HomeAssessmentLibrary; 